import { Card } from 'components/core-v2'
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import {
  AssetDrawdownModal,
  SingleAssetDrawdown
} from '../../../components/core-v2/organisms/asset-drawdown-modal/asset-drawdown-modal'
import { useAppSelector } from '../store/hooks'
import ScenarioStateless from '../templates/scenario-stateless'

const FILTER_VALUES = ['assets', 'fund-managers']

export const ScenarioPage = () => {
  const form = useForm<any>({
    defaultValues: { filter: FILTER_VALUES[0], shock: 0, selectedId: null }
  })
  const { setValue, watch } = form
  const [filterValue, selectedIdValue] = watch(['filter', 'selectedId'])
  const isFundManagersSelected = filterValue === FILTER_VALUES[1]

  const state = useAppSelector(x => x.gapRisk)
  const [singleAssetDrawdown, setSingleAssetDrawdown] = useState<SingleAssetDrawdown>(undefined)
  const ladder = isFundManagersSelected ? state.fundManagerLadder : state.scenarioLadder

  const onAssetClick = (assetId: string) => {
    const drawdownResult = isFundManagersSelected
      ? state.fundManagerDrawdownResult
      : state.singleAssetDrawdownResult
    const scenarioForAssetRecord = Object.keys(drawdownResult.values).find(item => item === assetId)
    if (scenarioForAssetRecord) {
      const record = { isinCode: assetId, values: drawdownResult.values[assetId] }
      setSingleAssetDrawdown(record)
    } else {
      setSingleAssetDrawdown(undefined)
    }
  }
  const onAssetDrawdownModalClose = () => {
    setSingleAssetDrawdown(undefined)
  }

  useEffect(() => {
    setValue(`${selectedIdValue}-checkbox`, false)
    setValue('selectedId', null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, filterValue])

  return (
    <Card.Wrapper spacing="sm">
      <FormProvider {...form}>
        <ScenarioStateless data={ladder} isLoading={state.isLoading} onAssetClick={onAssetClick} />
        <AssetDrawdownModal
          data={singleAssetDrawdown}
          isOpen={Boolean(singleAssetDrawdown)}
          onClose={onAssetDrawdownModalClose}
        />
      </FormProvider>
    </Card.Wrapper>
  )
}
